export default {
  buttons: {
    send_code: 'Envoyer le code de connexion',
  },
  placeholders: {
    mobile_number: 'Numéro de mobile',
    email: 'Adresse e-mail',
  },
  feedback: {
    phone_number_required: 'Veuillez saisir votre numéro de téléphone',
    email_required: 'Veuillez saisir votre adresse e-mail',
  },
};
